export default { options: { label: 'Careers' } }
